import React, { useEffect, useRef, useState } from 'react'
import { useTrans, useTealium } from '@next-nx/hooks'
import { Button } from '@next-nx/shared-ui/atoms'
import { StoreLocatorResultsItem } from '@next-nx/shared-ui/molecules'
import { getTimestamp } from '@next-nx/utils';
import _ from 'lodash'
import styles from './StoreLocatorResults.module.sass'


interface Props {
  type: string
  results: any[]
  ctaLabel: string
  goToItem: number|null
  setGoToItem: (v: number | null) => void
  selectedItem: number|null
  setSelectedItem: (v: number | null) => void
  option?: any
  className?: string
}

const StoreLocatorResults = (props: Props) => {

  const {
    type = '',
    results = [],
    ctaLabel = '',
    goToItem = null,
    setGoToItem = () => undefined,
    selectedItem = null,
    setSelectedItem = () => undefined,
    option = null,
    className = '',
  } = props

  const t = useTrans()
  const [open, setOpen] = useState(true)
  const innerContentRef = useRef(null)
  
  const listRef = useRef(null)
  const itemsRefs = useRef<{[key: number]: HTMLDivElement|null}>({})

  useEffect(() => {
    if (goToItem && listRef?.current && itemsRefs?.current?.[goToItem]){
      listRef.current.scrollTo({ top: itemsRefs.current[goToItem].offsetTop - listRef.current.offsetTop })
    }
    setGoToItem(null)
  }, [goToItem])

  const { linkDataLayer } = useTealium()

  const handleTracking = (action_type: string = '') => {
    const action_timestamp = getTimestamp()
    let name = type === 'agenzie' ? type : type === 'centri_convenzionati' ? 'strutture_convenzionate' : 'filiali'

    linkDataLayer({
      virtual: 'action',
      action_name: 'storelocator', 
      action_tech: 'click',
      action_type: `${name}_${action_type?.replace(/ /g, '_').toLowerCase()}`,
      action_timestamp,
      action_effect: `${name}_interazione_generale`,
    })
  }

  return (
    <div className={`${styles.root} ${open ? styles['root--open'] : ''} ${className}`}>
      <div className={styles.header}>
        <div className={styles.num}>{t(results.length !== 1 ? "{0} risultati trovati" : "1 risultato trovato", [results.length.toString()])}</div>
        {!!results?.length && <Button label={t(open ? "Nascondi elenco" : "Espandi elenco")} variant="ghost" onClick={() => {setOpen(!open), handleTracking(open ? "Nascondi elenco" : "Espandi elenco")}} size="sm" />}
      </div>
      {!!results?.length && (
        <div className={styles.content}>
          <div className={styles.innerContent} ref={innerContentRef}>
            <div className={styles.list} ref={listRef}>
              {_.sortBy(results, ["distance"]).map(x => (
                <div key={x.pk} ref={(element) => itemsRefs.current[x.pk] = element}>
                  <StoreLocatorResultsItem type={type} option={option} item={x} ctaLabel={ctaLabel} selected={selectedItem === x.pk} setSelected={() => setSelectedItem(x.pk)} />
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default StoreLocatorResults
